import React from "react";
import { formatDateTimeToFullDatTime } from "../../utils/utils";
import { imageBaseUrl } from "../../constants/ApiConstants";
import styled from "styled-components";

const AppointmentCard = ({ appointmentData }) => {
  const statusTextMap = {
    0: "Waiting for confirmation",
    1: "Accepted",
    2: "Completed",
    3: "Declined",
    4: "Cencelled",
  };
  const statusBgColorClassMap = {
    0: "bg-info-surface",
    1: "bg-warning-surface",
    2: "bg-success-surface",
    3: "bg-danger-surface",
    4: "bg-danger-surface",
  };
  return (
    <Wrapper href={`/appointment-details/${appointmentData.id}`} key={appointmentData.id} className="cursor-pointer col-md-4 bg-grey2 d-flex flex-column">
      <div className="w-full d-flex align-items-center py-1 ">
        <img className="p-1" src={`${imageBaseUrl}${appointmentData.doctor?.image}`} alt="Doctor Image" style={{ height: 80, widows: 80, objectFit: "cover" }} />
        <div className="d-flex flex-column justify-content-around">
          <strong className="text-black fw-bold fs-normal">{appointmentData.doctor?.name}</strong>
          <span className="fs-md">{appointmentData.doctor?.designation}</span>
          <span className="fs-sm text-muted">{formatDateTimeToFullDatTime(appointmentData?.created_at)}</span>
        </div>
      </div>
      <div className={`py-2 px-2 ${statusBgColorClassMap[appointmentData.status]}`}>
        <span className="d-block text-end">{`${statusTextMap[appointmentData.status]}`}</span>
      </div>
    </Wrapper>
  );
};

export default AppointmentCard;

const Wrapper = styled.a`
  cursor: pointer;
  &:hover {
    background-color: #e3e3e3;
    transition: all ease-in-out 0.3s;
  }
`;
